<template>
  <div class="indexbox">
    <div class="headbg">
      <!-- <div>
        <h3>城轨实验课程云平台</h3>
        <p>持续提供创新性、高阶性、挑战度的在线实验</p>
      </div> -->
    </div>
    <div class="writebg">
    </div>
    <div class="notice">
      <Row>
        <Col :span="11">
        <Carousel autoplay loop autoplay-speed="5000" :radius-dot="true">
          <CarouselItem>
            <img src="../../assets/home/item1.jpg" alt="">
            <p>2023金砖国家职业技能大赛城市轨道交通运营设计与应急处理赛项...</p>
          </CarouselItem>
          <CarouselItem>
            <img src="../../assets/home/item2.jpg" alt="">
            <p>2023年重庆市职业院校技能大赛（中职组）城市轨道交通运营与...</p>
          </CarouselItem>
          <CarouselItem>
            <img src="../../assets/home/item3.jpg" alt="">
            <p>2024年广东省职业院校技能大赛城市轨道交通运营与维护...</p>
          </CarouselItem>
        </Carousel>
        </Col>
        <Col :span="13">
        <h3><span>通知</span></h3>
        <ul>
          <li><a>2023金砖国家职业技能大赛城市轨道交通运营设计与应急处理赛项国际总决赛成功举办！</a> <span>2023-11-12 14:03</span></li>
          <li><a>2023年重庆市职业院校技能大赛（中职组）城市轨道交通运营与维护赛项成功举办！ </a><span>2024-01-08 17:33</span></li>
          <li><a>2024年广东省职业院校技能大赛城市轨道交通运营与维护赛项圆满举办！</a><span>2024-01-09 17:55</span> </li>
          <li><a>2023—2024年度安徽省职业院校技能大赛（中职组）城市轨道交通运营与维护赛项顺利举办！</a><span>2024-01-15 17:56</span> </li>
          <li><a>产教融合 | 全国智慧交通产教融合共同体成立仪式在广州隆重举行</a><span>2024-01-23 17:27</span></li>
          <li><a>央视新闻报道 | 友道科技有限公司赴沪参加“数智未来”教育展</a> <span>2024-02-01 09:01</span></li>
          <li><a>通知 | 友道科技荣获2023年广西交通运输行业职业技能竞赛突出贡献奖 </a><span>2024-02-27 16:48</span></li>
        </ul>
        </Col>
      </Row>
    </div>
    <div class="hot">
      <div class="wrap">
        <h3>最热实验项目</h3>
        <Row :gutter="20">
          <Col :span="6" v-for="(item,index) in datalist" :key="index">
          <a :href="item.link" target="_blank">
            <div class="item">
              <img :src="item.img" alt="">
              <div class="bg"></div>
              <p>{{ item.title }}</p>
            </div>
          </a>
          </Col>
        </Row>
      </div>
    </div>
    <!-- <WebSite></WebSite> -->
  </div>
</template>

<script>
// import WebSite from '../../views/WebSite.vue';

export default {
  name: "Home",
  // components: {
  //   WebSite,
  // },
  data() {
    return {
      // datalist: [
      //   {
      //     title: "线路客流特征分析系统",
      //     img: require("../../assets/home/pic01.png"),
      //     link: "http://192.168.0.114:62003",
      //   },
      //   {
      //     title: "列车开行方案设计系统",
      //     img: require("../../assets/home/pic02.png"),
      //     link: "http://192.168.0.114:62004",
      //   },
      //   {
      //     title: "运行图编制系统",
      //     img: require("../../assets/home/pic03.png"),
      //     link: "http://192.168.0.114:62005",
      //   },
      //   {
      //     title: "乘务计划编制系统",
      //     img: require("../../assets/home/pic04.png"),
      //     link: "http://192.168.0.114:62006",
      //   },
      // ],
      datalist: [
        {
          title: "线路客流特征分析系统",
          img: require("../../assets/home/pic01.png"),
          link: "http://urtom.pfa.yoodao.net",
        },
        {
          title: "列车开行方案设计系统",
          img: require("../../assets/home/pic02.png"),
          link: "http://urtom.osd.yoodao.net",
        },
        {
          title: "运行图编制系统",
          img: require("../../assets/home/pic03.png"),
          link: "http://urtom.td.yoodao.net",
        },
        {
          title: "乘务计划编制系统",
          img: require("../../assets/home/pic04.png"),
          link: "http://urtom.cp.yoodao.net",
        },
      ],
    };
  },
  setup() {},
  methods: {
    handleClick() {
      this.$Message.info("Welcome to View UI Plus Demo!");
    },
  },
};
</script>
<style lang="less" scoped>
.headbg {
  height: 310px;
  width: 100%;
  background: url(../../assets/home/headbg.png) no-repeat center;
  overflow: hidden;
  > div {
    width: 1200px;
    margin: 0 auto;
    padding-top: 80px;
    h3 {
      font-size: 32px;
    }
    p {
      font-size: 18px;
      color: #555;
    }
  }
}
.notice {
  height: 320px;
  width: 1200px;
  background-color: #fff;
  margin: -340px auto 20px;
  box-shadow: 0 0 10px #ddd;
  padding: 10px;
  .ivu-carousel-item {
    position: relative;
    p {
      position: absolute;
      bottom: 5px;
      color: #fff;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
    }
  }
  :deep(.ivu-carousel-dots-inside) {
    // background: rgba(0, 0, 0, 0.60);
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: right;
    padding-right: 20px;
  }
  h3 {
    height: 40px;
    border-bottom: 1px solid #ddd;
    font-size: 18px;
    color: red;
    span {
      display: inline-block;
      border-bottom: 2px solid red;
      height: 40px;
      padding-right: 10px;
    }
  }
  ul {
    margin-top: 10px;
    li {
      line-height: 36px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      a {
        display: inline-block;
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #333;
      }
    }
  }
}
.writebg {
  height: 280px;
  background-color: #fff;
}
.ivu-carousel {
  width: 480px;
}
.hot {
  background: url(../../assets/home/bg1.png) no-repeat center;
  .wrap {
    width: 1200px;
    margin: 0 auto 0;
    padding-top: 10px;
    h3 {
      color: red;
      text-align: center;
      font-size: 24px;
      margin-bottom: 30px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 40px;
        left: 50%;
        margin-left: -15px;
        width: 30px;
        height: 3px;
        background-color: red;
      }
    }
    .item {
      width: 270px;
      height: 200px;
      position: relative;
      cursor: pointer;
      margin: 0 auto;
      .bg{
        position: absolute;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 180px;
      }
      img {
        border-radius: 5px;
      }
      p {
        position: absolute;
        top: 80px;
        text-align: center;
        width: 100%;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}
</style>

